import { TextAssist } from '../comments/TextAssist';
import { useState } from 'react';
import type { V2Evidence } from '../../domain/evidence';
import { useT } from '../../i18n/i18n';
import { setEvidenceCaptionAction } from '../../state/evidenceStore';
import { Button, SheetShell, TextArea } from '../../ui/components';
import { Thumbnail } from './PhotoStrip';

// A note on one photo (Round 2 §T): reachable from every photo card, saved on the evidence record,
// shown in the pool and sent to the AI as that photo's note.
export function PhotoNoteSheet(props: { evidence: V2Evidence; onClose: () => void; layer?: 'over' | 'top' }) {
  const { t, locale } = useT();
  const [value, setValue] = useState(props.evidence.caption);
  const [busy, setBusy] = useState(false);

  async function save() {
    setBusy(true);
    try {
      await setEvidenceCaptionAction(props.evidence.id, value.trim());
      props.onClose();
    } finally {
      setBusy(false);
    }
  }

  return (
    <SheetShell
      title={t('photo.noteTitle')}
      subtitle={t('photo.noteSubtitle')}
      onClose={props.onClose}
      layer={props.layer ?? 'over'}
      testId="photo-note-sheet"
      footer={
        <>
          <Button onClick={() => void save()} disabled={busy} icon="save" testId="photo-note-save">
            {t('photo.noteSave')}
          </Button>
          <Button variant="text" onClick={props.onClose} testId="photo-note-cancel">
            {t('shell.cancel')}
          </Button>
        </>
      }
    >
      <div className="photo-note-preview">
        <Thumbnail evidence={props.evidence} onClick={() => undefined} />
      </div>
      <TextArea id="photo-note-input" value={value} onChange={setValue} placeholder={t('photo.notePlaceholder')} rows={4} testId="photo-note-input" />
      <TextAssist value={value} onChange={setValue} fieldId="photo-note-input" lang={locale} testId="photo-note-assist" />
      <p className="card-note">{t('photo.noteHint')}</p>
    </SheetShell>
  );
}
